(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyDialogController', TradePolicyDialogController);

    TradePolicyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TradePolicy'];

    function TradePolicyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TradePolicy) {
        var vm = this;
        vm.tradePolicy = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:tradePolicyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tradePolicy.id !== null) {
                TradePolicy.update(vm.tradePolicy, onSaveSuccess, onSaveError);
            } else {
                TradePolicy.save(vm.tradePolicy, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
